import { GameSystem } from '../types';

export interface GameDefinition {
  id: GameSystem;
  name: string;
  partyName: string;
  abilitiesName: string;
  itemsName: string;
  homeName: string;
}

export const gameDefinitions: Record<GameSystem, GameDefinition> = {
  frostgrave: {
    id: 'frostgrave',
    name: 'Frostgrave',
    partyName: 'Warband',
    abilitiesName: 'Spells',
    itemsName: 'Magic Items',
    homeName: 'Base',
  },
  stargrave: {
    id: 'stargrave',
    name: 'Stargrave',
    partyName: 'Crew',
    abilitiesName: 'Powers',
    itemsName: 'Cargo',
    homeName: 'Ship',
  },
};

export const getGameDefinition = (gameSystem: GameSystem): GameDefinition =>
  gameDefinitions[gameSystem];